module.exports = __webpack_public_path__ + "img/email.b8634972.svg";